<template>
  <div class="page-content" style="padding-top: 4rem">
    <InfoCard :infoData="infoDetails" :loading="loading" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">
          <div class="card-header border-0">
            <div class="d-flex align-items-center" style="text-align: left">
              <h5 class="card-title mb-0 flex-grow-1">All Referrals</h5>
              <div class="flex-shrink-0">
                <button
                  type="button"
                  class="btn btn-info"
                  @click="exportReferralsAsCSV()"
                  fdprocessedid="1yahzs"
                >
                  <i class="ri-download-line align-bottom me-1"></i> Export
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-body border border-dashed border-end-0 border-start-0"
          >
            <form>
              <div class="row g-3 align-items-center">
                <div class="col-xxl-5 col-sm-6">
                  <div class="search-box">
                    <input
                      type="text"
                      class="form-control search"
                      v-model="searchKey"
                      @keydown.enter.prevent
                      @input="fetchList(1)"
                      placeholder="Enter Your Phone Number"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body pt-0">
            <div class="mt-5">
              <div class="table-responsive table-card mb-1">
                <div class="noresult" v-if="loading">
                  <rb-loading-table />
                </div>
                <div v-else>
                  <rb-data-table
                    :ldata="ldata"
                    title="referral"
                    :headers="headers"
                    :tableData="formattedReferrals"
                    @edit="editRefferal"
                  />
                </div>
              </div>

              <div class="d-flex justify-content-end" v-if="!loading">
                <div class="me-3">
                  <select
                    class="form-select w-auto"
                    v-model="limit"
                    @change="fetchList(1)"
                  >
                    <template
                      v-for="(role, index) in paginationOptions"
                      :key="index"
                    >
                      <option :value="role">{{ role }}</option>
                    </template>
                  </select>
                </div>

                <div class="pagination-wrap hstack gap-2" style="display: flex">
                  <a
                    class="page-item pagination-prev px-4"
                    v-if="pageNo > 1"
                    @click="fetchList(pageNo - 1)"
                    href="javascript:void(0)"
                  >
                    <i class="ri-arrow-left-line"></i>
                  </a>

                  <ul
                    class="pagination listjs-pagination mb-0"
                    v-if="Array.isArray(referral) && referral.length > 0"
                  >
                    <li class="active">
                      <a class="page" href="javascript:void(0)">{{ pageNo }}</a>
                    </li>
                    <li v-if="referral.length >= limit">
                      <a
                        class="page"
                        href="javascript:void(0)"
                        @click="fetchList(pageNo + 1)"
                      >
                        {{ pageNo + 1 }}
                      </a>
                    </li>
                  </ul>

                  <a
                    class="page-item pagination-next px-4"
                    v-if="referral.length >= limit"
                    href="javascript:void(0)"
                    @click="fetchList(pageNo + 1)"
                  >
                    <i class="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastNotification ref="toast" />
        <LoaderLoading v-if="overallLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { getReferralData, getReferralByCode } from "@/apis/referral";
import listMixin from "@/mixins/listMixin";

export default {
  name: "ReferralPage",
  mixins: [listMixin],

  data() {
    return {
      infoDetails: [
        {
          title: "Total Referrals",
          icon: "ri-group-line",
          count: 0,
        },
        {
          title: "User Referrals",
          icon: "ri-user-follow-line",
          count: 0,
        },
        {
          title: "Total Reward Distributed",
          icon: "ri-arrow-up-s-line",
          count: 0,
        },
      ],
      headers: [
        { name: "Refferrer" },
        { name: " Type" },
        { name: "Total Refferals" },
        { name: "Successfull Refferals" },
        { name: "Reward Earned" },
        { name: "Live WB" },
        { name: "Created Date" },
        {
          name: "Status",
          auth: true,
        },
        {
          name: "Actions",
          auth: true,
        },
      ],
      referral: [],

      searchKey: "",
    };
  },
  methods: {
    exportReferralsAsCSV() {
      const fields = [
        "mobile",
        "type",
        "totalReferral",
        "successReferral",
        "rewardsEarned",
        "liveWallet",
        "createdAt",
        "status",
      ];
      this.$exportCsv(this.formattedReferrals, "Refferal.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getReferralData, {
        referral_code:this.searchKey
      });

      this.referral = response.data;
      this.infoDetails[0].count = response?.total_count;
      this.infoDetails[1].count = response?.success_count;
      this.infoDetails[2].count = response?.total_reward_earned;
    },

    async editRefferal(referral) {
      await this.update(
        getReferralByCode,
        referral.mobile,
        "/viewRefferal",
        "referral_code"
      );
    },
  },

  computed: {
    formattedReferrals() {
      return this.referral.map((user) => ({
        id: user.id,
        mobile: user.referral_code,
        type: user.user_type || "N/A",
        totalReferral: user.total_referrals,
        successReferral: user.success_referrals,
        rewardsEarned: user.reward_earned,
        liveWallet: user.wallet_balance || "N/A",
        createdAt: user.created_at
          ? new Date(user.created_at).toLocaleString()
          : "N/A",
        status: user.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
